'use strict';

define('components/nav/navigation.gxp',['./navigation'], function (Navigation) {
  var __participantTDA = BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled';

  var gxpPlugin = Navigation.Plugin.extend({
    onRendered: function () {
      if (__participantTDA) {
        $('.site-nav-utility').append('<li style="height: 30px;"><div id="dg-component-nav-menu-desktop"></div></li>');
        $('.site-nav-mobile-top-bar').children('.site-nav-zip').css('flex', '0');
        $('<div class="site-nav-gxp"><div id="dg-component-nav-menu-mobile"></div>').insertAfter('.site-nav-mobile-top-bar .site-nav-zip');
      }
    }
  });

  Navigation.registerPlugin(gxpPlugin);
});

